module.exports = __webpack_public_path__ + "static/media/VectorPointInacabado4.c4d4d903.svg";